function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31 32.5C31 46.5833 24.0604 51 15.5 51C6.93959 51 0 46.5833 0 32.5C0 18.4167 15.5 0 15.5 0C15.5 0 31 18.4167 31 32.5Z",
  fill: "#F8F8F8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3964 50.9834C22.0323 48.7894 26 42.7634 26 30.2353C26 20.1057 20.2064 8.07046 15.7033 0.245972C17.5268 2.47266 31 19.3698 31 32.5C31 46.0883 24.5397 50.6776 16.3964 50.9834Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 51,
  x2: 16,
  y2: 56,
  stroke: "#EEEEEE",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 255,
  cy: 32,
  r: 16,
  fill: "#F8F8F8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 32,
  r: 16,
  fill: "#F8F8F8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M257.563 47.7959C262.651 44.3869 266 38.5846 266 32C266 25.4154 262.651 19.6132 257.562 16.2041C265.181 17.4304 271 24.0357 271 32C271 39.9644 265.181 46.5696 257.563 47.7959Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.5625 47.7959C62.6506 44.3869 66.0001 38.5846 66.0001 32C66.0001 25.4154 62.6506 19.6132 57.5625 16.2041C65.181 17.4304 71.0001 24.0357 71.0001 32C71.0001 39.9644 65.181 46.5696 57.5625 47.7959Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 256,
  y1: 48,
  x2: 256,
  y2: 56,
  stroke: "#EEEEEE",
  strokeWidth: 2
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 48,
  x2: 56,
  y2: 56,
  stroke: "#EEEEEE",
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M143.5 34C142.382 34 142.045 34.5 142.045 35.6299C142.045 36.7598 143.097 36.9601 143.045 37.63C142.961 38.7313 141.468 38.6096 141.045 39.63C140.622 40.6503 143.295 56.63 143.295 56.63L143.045 57.13L142.045 57.63C141.879 58.13 142.245 58.03 145.045 57.63C145.045 50.13 146.33 40.8067 145.545 39.63C144.545 38.13 143.689 39.13 143.689 37.63C143.689 36.7894 144.545 36.63 144.545 35.63C144.545 34.63 144 34 143.5 34Z",
  fill: "#010101"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M145 39.5L147 42.5L144 47",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M141.5 40V44.5L141 49",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInviteTheAgentBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 58,
    viewBox: "0 0 271 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteTheAgentBanner);
export default __webpack_public_path__ + "static/media/invite-the-agent-banner.77bbe351.svg";
export { ForwardRef as ReactComponent };